import { createStore } from 'vuex'

export default createStore({
  state: {
    wbnb: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
    USDT: '0x55d398326f99059fF775485246999027B3197955',
    DP: '0x21dfe97101717ed7f562da5D1Ccbceef8fef33c3',
    DBTCoinNew: '0x9643C079291f36bAf1d4B2C9FB4657D4307A198a',
    MintDBTC: '0x2c78Cb506100E1ede3B2981cEaAAB4E41c1B7dB7',
    MintDBTCPlus: '0x19a8F764b9557E30b661b5a2FEb8A2d2C201848c',
    BTC: '0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c',
    ETH: '0x2170Ed0880ac9A755fd29B2688956BD959F933F8',
    BCH: '0x8fF795a6F4D97E7887C79beA79aba5cc76444aDf',
    SOL: '0x570A5D26f7765Ecb712C0924E4De545B89fD43dF',
    DOGE: '0xbA2aE424d960c26247Dd6c32edC70B295c744C43',
    TON: '0x76A797A59Ba2C17726896976B7B3747BfD1d220f',
    MorningStar: '0xd06b94a6af942ac2eefc4658f23b2c2e34131419',
    FP: '0x9eb026b4861b679e2c6653389868ace280985f4b',
    USDP: '0x4aBAA97C173A028188A801fbc718B3D6a7F57d9c',
    Mars: '0x660455B21e82709bbc85D27a1c24797e13aAf533',
    SwapDBTC: '0x8Ed182503d9260E137AE3229B03386eD10CD456A',
    EGA: '0x66FDe17C6bBd7E0f523b396c9fB02bec29e427d2',
    C13: '0x7D1FFFD3cE989A95dF96d060Ff93bFdC369Dfd04',
    MIAO: '0xe87739e3494ae2afe555cdd46df45050cc709522',
    BTL: '0x94833cf5fe10536f5a427ed265ff46b03f902100',
    USDA: '0xE70302FB21f61AEe47bC2D63E529870c728d4b5A',
    USDASwap: '0x830821308e4087112f7F1fe7ed333a0DD721F4EC',
    CGM: '0x4c59a80b01ea7254af34a1a11eea54a4ae918520',
    lianjeshow: false
  },
  getters: {
  },
  mutations: {
    backlianje(state, i) {//修改登录
      state.lianjeshow = i
    },
  },
  actions: {
  },
  modules: {
  }
})
